import React from "react";

import { Lending } from "../../components/Lending";

export const LendingParaDjanov = () => {
  return (
    <>
      <Lending title="Пара Джанов і Портвейн" />
    </>
  );
};
